/**
 * Workspace Limits and Storage Constants Configuration
 * 
 * Central single source of truth for all project size limits, workspace memory limits,
 * image optimizer thresholds, and Firebase cloud save ceilings.
 * Modify values here to dynamically update limits across the entire platform.
 */

export const WORKSPACE_LIMITS = {
  // 1. Workspace Working Memory Limit (500 KB)
  // Governs live in-browser editing for Junior Blocks (junior.html) and Standard Blocks (index.html)
  WORKSPACE_MEMORY_LIMIT_BYTES: 500 * 1024, // 512,000 bytes

  // 2. Local Computer File Import Limit (500 KB)
  // Governs local disk import (.sb3, .zip, .py, .js) in useWorkspaceFileIO.js
  LOCAL_FILE_IMPORT_LIMIT_BYTES: 500 * 1024, // 512,000 bytes

  // 3. Workspace Project Service Baseline Limit (500 KB)
  // Baseline ceiling for creating/working on workspace projects in projectService.js
  PROJECT_SERVICE_LIMIT_BYTES: 500 * 1024, // 512,000 bytes

  // 4. Firebase Cloud Save / Sync Ceiling (100 KB)
  // Maximum project package size permitted for Firestore / cloud sync in projectService.js
  FIREBASE_CLOUD_SAVE_LIMIT_BYTES: 100 * 1024, // 102,400 bytes

  // 5. Automatic Client-Side Image Optimizer Thresholds
  IMAGE_OPTIMIZER: {
    BACKDROP: {
      MAX_WIDTH: 640,
      MAX_HEIGHT: 480,
      QUALITY: 0.78,
      SIZE_THRESHOLD_BYTES: 50 * 1024, // 50 KB auto-compress trigger
    },
    SPRITE: {
      MAX_WIDTH: 360,
      MAX_HEIGHT: 360,
      QUALITY: 0.80,
      SIZE_THRESHOLD_BYTES: 50 * 1024, // 50 KB auto-compress trigger
    },
  },
};

export default WORKSPACE_LIMITS;
